var render = function render(){var _vm=this,_c=_vm._self._c;return _c('App',{attrs:{"session":_vm.session}},[(_vm.loading)?_c('i',{staticClass:"load"}):_vm._e(),(!_vm.loading)?_c('div',[_c('iframe',{staticClass:"_iframe",attrs:{"src":"https://jesusm32.sg-host.com/"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }